const items = [
  "Éduquer",
  "Donner accès à l'expertise",
  "Soutenir",
  "Financer",
  "L'expertise au service de l'autonomie",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-espresso-border bg-espresso py-6" data-testid="editorial-marquee" aria-hidden="true">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {items.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center whitespace-nowrap">
              <span className="font-serif text-2xl italic tracking-wide text-ivory/90 md:text-3xl">{item}</span>
              <span className="mx-8 text-gold">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
